module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./~/dom-serializer/~/entities/lib/maps/xml.json
// module id = 317
// module chunks = 1 3